module.exports = __webpack_public_path__ + "static/media/KEBAB-BUSD.437b9352.png";